module.exports = __webpack_public_path__ + "media/assets/services_manager/logos/managebac-87934bbb5cdddba83921c2e5cba8b25b89501d0b38878c3199e29f02db3e2ab1.png";